<template>
  <task-list
    :columns="computedColumns"
    :personalTasks="personalTasks"
    :headerText="$t('task.header.titlePersonal')"
    :overview="overview || undefined"
    @personalDateRange="fetchPersonalTasks"
  />
</template>
<script>
import TaskList from './TaskList';

export default {
  props: {
    overview: {
      type: Boolean, // from index file
    },
  },

  components: {
    TaskList,
  },

  mounted() {
    this.fetchPersonalTasks();
    this.$root.$on('personalTasks', () => {
      this.fetchPersonalTasks();
    });
  },

  data() {
    return {
      personalTasks: [],
    };
  },

  computed: {
    computedColumns() {
      let cols = [];
      if (this.overview) {
        cols = ['Title', 'DueDate', 'Status'];
      } else {
        cols = ['Title', 'AssignedBy', 'CreationDate', 'DueDate', 'Status'];
      }
      return cols;
    },
  },

  methods: {
    fetchPersonalTasks(type) {
      const currentUserId = this.$store.state.user.informations.reference;
      this.$services.task.personalTasks(currentUserId, type).then((res) => {
        this.personalTasks = res.data;
      });
    },
  },
};
</script>
